import request from '@/config/axios'

export interface O2oReviewReplyItemVO {
  content?: string
  replyTime?: string
  source?: string
  institutionName?: string
}

export interface O2oReviewVO {
  id?: number
  orderId?: number
  orderNo?: string
  userId?: number
  userNickname?: string
  providerId?: number
  providerName?: string
  serviceId?: number
  serviceName?: string
  institutionId?: number
  institutionName?: string
  ratingsJson?: Record<string, number>
  overallScore?: number
  content?: string
  images?: string[]
  tags?: string
  anonymous?: boolean
  status?: string
  replyContent?: string
  replyTime?: Date
  replied?: boolean
  replies?: O2oReviewReplyItemVO[]
  createTime?: Date
}

/** O2O 评论管理 — /admin-api/o2o/review/* */
export const O2oReviewApi = {
  getPage: async (params: any) => {
    return await request.get<PageResult<O2oReviewVO[]>>({ url: '/o2o/review/page', params })
  },
  get: async (id: number) => {
    return await request.get<O2oReviewVO>({ url: '/o2o/review/get', params: { id } })
  },
  updateStatus: async (data: { id: number; status: string }) => {
    return await request.put({ url: '/o2o/review/update-status', data })
  }
}
